import { PublicPage as BasePublicPage } from "@/marketing/PublicPageBase";
import {
  DocumentationPublicPage,
  documentationPublicPath,
} from "@/marketing/documentation/DocumentationPublicPage";

export function PublicPage({ path }: { path: string }) {
  if (documentationPublicPath(path)) {
    return <DocumentationPublicPage path={path} />;
  }
  return <BasePublicPage path={path} />;
}
